import { LitElement, html, css, PropertyValues } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { JobindsatsElement } from '../core/jobindsats-element';

@customElement('ji-dialog-element')
export class DialogElement extends JobindsatsElement(LitElement) {
    static styles = css`
        @keyframes fadeout {
            from {
                opacity: 1;
            }
            to {
                opacity: 0;
            }
        }
        .fadeout {
            animation-duration: 200ms;
            animation-name: fadeout;
        }
        .ji-dialog-overlay {
            z-index: 10000000;
            position: fixed;
            top: 0;
            left: 0;
            height: 100vh;
            width: 100vw;
            background-color: rgba(0,0,0,0.5);
        }
        .dialog-title-container {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .dialog-content-container {
            background-color: white;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .dialog-close button {
            background: white;
            border: none;
            color: white;
            font-size: 18px;
            padding: 5px 10px;
            cursor: pointer;
            font-size: inherit;
            color: var(--link-color);
        }
        .dialog-close {
            padding-left: 150px;
        }
        .ji-dialog {
            z-index: 10000000;
            min-width: 320px;
            background-color: white;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            padding-left: 30px;
            padding-right: 20px;
            padding-top: 10px;
            padding-bottom: 20px;
        }
        .glyphicon{
            padding-right: 10px;
        }
    `;

    @property()
    closeButtonText: string = 'Luk';

    @property()
    title: string = '';

    @property()
    visible: boolean = false;

    @state()
    fadeOut: boolean = false;

    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
    }

    handleKeydown = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
            this.handleEscapePressed();
        }
    };


    handleEscapePressed() {
        this.closeDialog();
    }

    render() {
        return this.visible ? html`
            <focus-trap>
                <div class=${'ji-dialog-overlay fade-element' + (this.fadeOut ? ' fadeout' : '')}  @click=${this.closeDialog}>
                    <aside class='ji-dialog' title=${this.title} role="dialog" aria-labelledby="dialogtitle" aria-describedby="dialogcontentcontainer" @click=${(ev: MouseEvent) =>  ev.stopPropagation()}>
                        <header class="dialog-title-container">
                            <h1 class="h2" id="dialogtitle">${this.title}</h1>
                            <div class="dialog-close">
                                <button id="closebutton" @click=${this.closeDialog}>
                                     <div class="glyphicon glyphicon-remove"></div>
                                    ${this.closeButtonText}
                                </button>
                            </div>
                        </header>
                        <div class="dialog-content-container" id="dialogcontentcontainer">
                            <slot></slot>
                        </div>
                    </aside>
                </div>
            </focus-trap>
        ` : html``;
    }

    closeDialog() {
        this.animateFadeOut();
    }

    animateFadeOut() {
        this.shadowRoot?.querySelector('.fade-element')?.addEventListener('animationend', () => {
            this.fireCloseEvent();
        });
        this.fadeOut = true;

    }

    updated(_changedProperties: PropertyValues): void {
        if (_changedProperties.has('visible')) {
            if (this.visible) {
                this.fadeOut = false;
                this.shadowRoot?.getElementById("closebutton")?.focus();
            }
        }
    }

    fireCloseEvent = () => {
        const closeEvent = new CustomEvent('closeDialog', {
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(closeEvent);
    };
}